import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'

import EstimateHeader from './EstimateHeader'
import EstimatePreview from './EstimatePreview'
import EstimateContent from './EstimateContent'
import EstimateFooter from './EstimateFooter'
import BillingFormValidationDialog from '../common/BillingFormValidationDialog'
import NewEstimateEditor from '../infra/NewEstimateEditor'
import DbEstimateEditor from '../infra/DbEstimateEditor'
import BillingItemDeletionConfirmationDialog from 'billing/common/modules/items/BillingItemDeletionConfirmationDialog'

const withEstimateEditor = (editor, isNewEstimate) => class Container extends React.Component {

  componentDidMount() {
    editor.initialize(this.props)
  }

  componentWillUnmount() {
    editor.release()
  }

  componentWillReceiveProps(nextProps) {
    editor.release()
    editor.initialize(nextProps)
  }

  render() {
    const props = { ...this.props, editor, isNewEstimate }
    return (
      <EstimateDialog {...props} />
    )
  }
}

export const NewEstimateDialog = withEstimateEditor(new NewEstimateEditor(), true)

export const EditEstimateDialog = withEstimateEditor(new DbEstimateEditor(), false)

class EstimateDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    mode: PropTypes.string.isRequired,
    teamId: PropTypes.string.isRequired,
    estimate: PropTypes.object,
    isNewEstimate: PropTypes.bool.isRequired,
    editor: PropTypes.object.isRequired,
    onSendEstimateSelected: PropTypes.func.isRequired,
    onCloseRequested: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      open: props.open,
      mode: props.mode,
      estimateVersion: 0,
      showEstimateValidationDialog: false,
      showReferenceInfoSlider: false,
      openSendEstimateDialog: false,
      showEstimateDeletionConfirmationDialog: false,
      sendingEstimateEmail: false,
      showEstimateSendStatusDialog: false
    }
    this.props.editor.addValueUpdatedListener(this.onValueUpdated)
  }

  onValueUpdated = () => {
    this.setState({
      estimateVersion: this.state.estimateVersion + 1
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open || nextProps.mode !== this.props.mode) {
      this.setState({
        open: nextProps.open,
        mode: nextProps.mode
      })
    }
  }

  handleReferenceInfoSliderBackClicked = () => {
    this.setState({
      showReferenceInfoSlider: false
    })
  }

  handleSwitchModeClicked = () => {
    this.setState({
      mode: this.state.mode === 'preview' ? 'edit' : 'preview'
    })
  }

  handleHamburgerClicked = () => {
    this.setState({
      showReferenceInfoSlider: true
    })
  }

  saveEstimate = () => {
    const saveResult = this.props.editor.save(this.props.teamId)
    if (!saveResult.success) {
      this.setState({
        showEstimateValidationDialog: true,
        validationErrorMessage: saveResult.error
      })
    }
    return saveResult
  }

  handleSaveAndSendClicked = () => {
    const saveResult = this.saveEstimate()
    if (saveResult.success) {
      this.props.onSendEstimateSelected(saveResult.estimate)
    }
  }

  handleSaveAsDraftClicked = () => {
    const saveResult = this.saveEstimate()
    if (saveResult.success) {
      this.props.onCloseRequested()
    }
  }

  handleDeleteClicked = () => {
    this.setState({
      showEstimateDeletionConfirmationDialog: true
    })
  }

  handleEstimateConfirmationDialogResult = result => {
    if (result) {
      this.props.editor.delete()
      this.props.onCloseRequested()
    }
    this.setState({
      showEstimateDeletionConfirmationDialog: false
    })
  }

  handleEstimateConfirmationDialogCloseRequested = () => {
    this.setState({
      showEstimateDeletionConfirmationDialog: false
    })
  }

  handleCloseValidationDialogRequested = () => {
    this.setState({
      showEstimateValidationDialog: false
    })
  }

  render() {
    if (!this.state.open) {
      return null
    }
    return (
      <div>
        <Dialog open={this.state.open} onRequestClose={this.props.onCloseRequested}
          bodyStyle={styles.dialogBody}
          title={
            <EstimateHeader
              title={this.props.isNewEstimate ? 'New Estimate' : `Estimate ${this.props.editor.getNumber()}`} 
              onCloseClicked={this.props.onCloseRequested}/>
          }
          actionsContainerStyle={{ padding: 0 }}
          actions={
            <EstimateFooter
              mode={this.state.mode}
              isNewEstimate={this.props.isNewEstimate}
              estimateStatus={this.props.estimate && this.props.estimate.status}
              onSwitchModeClicked={this.handleSwitchModeClicked}
              onSaveAndSendClicked={this.handleSaveAndSendClicked}
              onSaveAsDraftClicked={this.handleSaveAsDraftClicked}
              onDeleteClicked={this.handleDeleteClicked} />
          }
          contentStyle={styles.dialogContent}
          autoScrollBodyContent={true}>
          <div>
            {
              this.state.mode === 'preview'
                ? <EstimatePreview
                  onBackClicked={this.handleSwitchModeClicked}
                  estimateEditor={this.props.editor} />
                : <EstimateContent
                  onHamburgerClicked={this.handleHamburgerClicked}
                  estimateVersion={this.state.estimateVersion}
                  estimateEditor={this.props.editor} />
            }
          </div>
        </Dialog>
        <BillingFormValidationDialog
          open={this.state.showEstimateValidationDialog}
          message={this.state.validationErrorMessage}
          onCloseRequested={this.handleCloseValidationDialogRequested} />
        <BillingItemDeletionConfirmationDialog
          open={this.state.showEstimateDeletionConfirmationDialog}
          billingEntity='estimate'
          onCloseRequested={this.handleEstimateConfirmationDialogCloseRequested}
          onDialogResult={this.handleEstimateConfirmationDialogResult} />
      </div>
    )
  }

}

const styles = {
  dialogContent: {
    borderRadius: 6,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto',
    width: '80%',
    maxWidth: 960
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0
  }
}



// WEBPACK FOOTER //
// ./src/billing/estimates/EstimateDialog.js